export enum TipoDespesa{

    GASTOS_GERAL, 
    GASTOS_FUNCIONARIO, 
    DIVIDA_FUNCIONARIO

}